import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SponsorService } from '../services/sponsor.service';
import { Sponsor } from '../models/sponsor.model';
import { NotificationService } from '../services/notification.service';

@Component({
  selector: 'app-sponsor-form',
  templateUrl: './sponsor-form.component.html'
})
export class SponsorFormComponent {
  constructor(public service: SponsorService, private notificationService: NotificationService) { }

  @Input() model: Sponsor;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  submitted = false;

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;
    if (!this.model.sponsorID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {

    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => {
        console.log(err);
      }
    )
  }


}

